/*
interface SISTEMA_PERMISSOES_INTERFACE {
  [key: string]: {
    MODULO: string
    PERMISSOES: {
      [key: string]: string
      // EXCLUIR: string,

    }
  }
}
*/


// TODO - Criar Novo Crud
export interface SISTEMA_PERMISSOES_INTERFACE {

  /*
  PARAMETRO: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }
*/

  DRG: {
    MODULO: string
    PERMISSOES: {
      CADASTRO_CORRESPONDENCIA: string
      DADOS_CORRESPONDENCIA: string
      ENVIAR_DRG: string
      CADASTRO_XML: string
      CADASTRO_SQL: string
    }
  },

  FATORRH: {
    MODULO: string
    PERMISSOES: {
      CADASTRO_CORRESPONDENCIA: string
      DADOS_CORRESPONDENCIA: string
      ENVIAR_FATORRH: string
      CADASTRO_JSON: string
      CADASTRO_SQL: string
    }
  },

  CLIENTES: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  GRUPOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  USUARIOS: {
    MODULO: string
    PERMISSOES: {
      USUARIOS_GLOBAIS: string
      CADASTRO_USUARIO_CLIENTE: string
    }
  }

  VEICULOS: {
    MODULO: string
    PERMISSOES: {
      MANUTENCAO: string
    }
  }

  RELATORIOS: {
    MODULO: string
    PERMISSOES: {
      HISTORICO_LOCALIZACAO: string
    }
  }

}

export const SISTEMA_PERMISSOES: SISTEMA_PERMISSOES_INTERFACE = {

  /*
  PARAMETRO: {
    MODULO: 'Parâmetros Gerais do Sistema',
    PERMISSOES: {
      MANUTENCAO: 'Aleração dos Parâmetros'
    }
  },
  */

  DRG: {
    MODULO: 'DRG',
    PERMISSOES: {
      CADASTRO_CORRESPONDENCIA: 'Cadastro de Correspondência DRG',
      DADOS_CORRESPONDENCIA: 'Dados de Correspondência DRG',
      ENVIAR_DRG: 'Enviar dados para DRG Brasil',
      CADASTRO_SQL: 'Cadastro de Instruções SQL',
      CADASTRO_XML: 'Cadastro de Modelos XML'
    }
  },

  FATORRH: {
    MODULO: 'Fator RH',
    PERMISSOES: {
      CADASTRO_CORRESPONDENCIA: 'Cadastro de Correspondência Fator RH',
      DADOS_CORRESPONDENCIA: 'Dados de Correspondência Fator RH',
      ENVIAR_FATORRH: 'Enviar dados para Fator RH Brasil',
      CADASTRO_SQL: 'Cadastro de Instruções SQL',
      CADASTRO_JSON: 'Cadastro de Modelos JSON'
    }
  },

  CLIENTES: {
    MODULO: 'Cadastro de Clientes',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Clientes'
    }
  },

  GRUPOS: {
    MODULO: 'Cadastro de Grupos de Usuários',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Grupos'
    }
  },

  USUARIOS: {
    MODULO: 'Cadastro de Usuário',
    PERMISSOES: {
      USUARIOS_GLOBAIS: 'Manutenção de Usuários Globais',
      CADASTRO_USUARIO_CLIENTE: 'Manutenção de Usuários de Clientes'
    }
  },

  VEICULOS: {
    MODULO: 'Cadastro de Veículos',
    PERMISSOES: {
      MANUTENCAO: 'Manutenção de Veículos'
    }
  },

  RELATORIOS: {
    MODULO: 'Relatórios',
    PERMISSOES: {
      HISTORICO_LOCALIZACAO: 'Histórico de Localização'
    }
  }
}
